import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastr = inject(ToastrService);
  const skip = req.headers.get('skipErrorHandler');
  return next(req).pipe(
    catchError((err) => {
      if (skip) {
        return throwError(() => err);
      }

      const msg = err?.title || 'compliance.something_went_wrong';
      // toastr.error(msg, 'Error');
      // }
      return throwError(() => err);
    })
  );
};
